import JSZip from 'jszip';
import { saveAs } from 'file-saver';
export const generateZip = async (files, zipFileName) => {
    const zip = new JSZip();
    const zippedFiles = [];
    if (files.length <= 0) {
        return;
    }
    files.forEach((file) => {
        const fileNameCounter = zippedFiles.filter((zippedFile) => zippedFile.fileName === file.fileName).length;
        const fileNameAppendix = fileNameCounter === 0 ? '' : ` (${fileNameCounter})`;
        const fileName = `${file.fileName}${fileNameAppendix}.${file.fileExtension}`;
        zip.file(fileName, file.content);
        zippedFiles.push(file);
    });
    const zipContent = await zip.generateAsync({ type: 'blob' });
    saveAs(zipContent, zipFileName);
};
